import SprievodnyDokumentList from './SprievodnyDokumentList';

export default SprievodnyDokumentList;
